import React, { useContext, useEffect, useState } from "react";
import Moment from "react-moment";
import { useHistory, useParams } from "react-router-dom";
import AppContext from "../../Context/AppContext";
import requestAxios from "../../util/requestAxios";
import AcreditadoInfoDetalle from "./AcreditadoInfoDetalle/AcreditadoInfoDetalle";
import ModalAdicion from "./ModalAdicion/ModalAdicion";
import ModalAdicionDemanda from "./ModalAdicionDemanda/ModalAdicionDemanda";
import Gestiones from "./Gestiones/Gestiones";
import Demandas from "./Demandas/Demandas";
import Domicilios from "./Domicilios/Domicilios";
import OtrosDomicilios from "./OtrosDomicilios/OtrosDomicilios";
import Referencias from "./Referencias/Referencias";
import MediosPago from "./MediosPago/MediosPago";
import NuevosDomicilios from "./NuevosDomicilios/NuevosDomicilios";
import "./AcreditadosDetalle.css";

const AcreditadosDetalle = () => {
  const { checkUserSession, contextAcreditado } = useContext(AppContext);
  const infoUs = checkUserSession();
  const { id } = useParams();
  const acreditadoInfo = contextAcreditado.getInfoAcreditado();
  const [currentTab, setCurrentTab] = useState(0);
  const [currentRow, setCurrentRow] = useState(0);
  const [showModalEdicion, setShowModalEdicion] = useState(false);
  const [showModalDemanda, setShowModalDemanda] = useState(false);
  const [ultimas7, setUltimas7] = useState({});
  const [datatableGestiones, setDatatableGestiones] = useState({
    columns: [
      {
        label: "",
        field: "objFind",
        width: 0,
      },
      {
        label: "GESTOR",
        field: "TipoGestionId",
        width: 50,
      },
      {
        label: "FECHA",
        field: "Fecha",
        width: 150,
        attributes: {
          "aria-controls": "DataTable",
          "aria-label": "Name",
        },
      },
      {
        label: "TIPO GESTIÓN",
        field: "tipoGestion",
        width: 200,
      },
      {
        label: "Comentario",
        field: "Comentario",
        width: 270,
      },

      {
        label: "Valoración",
        field: "Valoracion",
        sort: "asc",
        width: 120,
      },

      {
        label: "Acciones",
        field: "AcreditadoId",
        sort: "disabled",
        width: 80,
      },
    ],
    rows: [],
  });
  const [datatableDemandas, setDatatableDemandas] = useState({
    columns: [
      {
        label: "",
        field: "objFind",
        width: 0,
      },
      {
        label: "EXP. JUDICIAL",
        field: "AsigDFolioDemanda",
        width: 20,
      },
      {
        label: "NO. EXP",
        field: "AsigDemandaId",
        width: 150,
        attributes: {
          "aria-controls": "DataTable",
          "aria-label": "Name",
          className: "itemDemandaNoExp",
        },
      },
      {
        label: "NO. JUZGADO",
        field: "JuzgadoNombre",
        width: 200,
      },
      {
        label: "TIPO JUICIO",
        field: "TipoJuicioNombre",
        width: 270,
      },
      {
        label: "Acciones",
        field: "AsigDemandaIdAC",
        sort: "disabled",
        width: 80,
      },
    ],
    rows: [],
  });

  useEffect(() => {
    loadInfo();
  }, []);
  async function loadInfo() {
    const { error, data } = await requestAxios({
      url: `Acreditados/getRegistrosMesPorAcreditado?acreditadoId=${id}`,
      method: "get",
      token: infoUs.bearer_token,
      data: {},
    });
    if (error === "") {
      contextAcreditado.setinfoAcreditado(data.infoCredito);
      setUltimas7(data.listUltimos7)
      setDatatableGestiones({
        ...datatableGestiones,
        rows: data.RegistrosMes.map((item, i) => ({
          objFind: `${item.AcreditadoId} ${item.ClaveGestor} ${item.Comentario} ${
            item.Valoracion != null && item.Valoracion.ValDescripcion
          }`,
          TipoGestionId: (
            <div className={`Gestor_AcreditadoDetalle`}>
              Ex.{item.AcreditadoId} <span>{item.ClaveGestor}</span>
            </div>
          ),
          Fecha: (
            <Moment
              className={`Fecha_AcreditadoDetalle`}
              locale="es"
              format="MMM DD, YYYY"
              date={item.Fecha}
            />
          ),
          tipoGestion: (
            <div
              className={`StatusDataTableAcreditadoDetalle__container Status${item.TipoGestion}DataTable__container`}
            >
              {item.TipoGestionNombre}
            </div>
          ),
          Comentario: (
            <div className="comentarioAcreditadoDetalle">{item.Comentario}</div>
          ),
          Valoracion: item.Valoracion != null && item.Valoracion.ValDescripcion,
          AcreditadoId: (
            <>
              <button
                className="btnAcreditadoDetalleExpediente"
                onClick={() => {
                  setCurrentRow({
                    GestionId: item.GestionID,
                    AcreditadoId: item.AcreditadoId,
                    TipoGestionId: item.TipoGestionId,
                    GesGBFechaRegistro: item.Fecha,
                    ValoracionId:
                      item.Valoracion == null
                        ? 0
                        : item.Valoracion.ValoracionId,
                    Comentarios: item.Comentario,
                    TipoComentario:""
                  });
                  setShowModalEdicion(true);
                }}
              >
                Editar
              </button>
              {/* <button
                className="btnRemoverExpediente"
                onClick={() => deleteRow(item.GestionID)}
              >
                <KTSVG
                  path={"/img/Icons/Remove.svg"}
                  className={`svg-icon removeItem`}
                />
              </button> */}
            </>
          ),
        })),
      });
      setDatatableDemandas({
        ...datatableDemandas,
        rows: data.demandas.map((item, i) => ({
          objFind: `${item.AsigDFolioDemanda} ${item.AsigDemandaId} ${item.JuzgadoNombre} ${item.TipoJuicioNombre}`,
          AsigDFolioDemanda: (
            <div className={`Gestor_AcreditadoDetalle`}>
              {item.AsigDFolioDemanda}
            </div>
          ),
          AsigDemandaId: id,
          JuzgadoNombre: item.JuzgadoNombre,
          TipoJuicioNombre: item.TipoJuicioNombre,
          AsigDemandaIdAC: (
            <>
              <button
                className="btnDetalleExpediente"
                onClick={() => {
                  setCurrentRow({
                    AsigDemandaId: item.data.AsigDemandaId,
                    JuzgadoId: item.data.JuzgadoId,
                    AcreditadoId: item.data.AcreditadoId,
                    AsigDfolioDemanda: item.data.AsigDfolioDemanda,
                    TipoJuicioId: item.data.TipoJuicioId,
                    AsigDComentarios: item.data.AsigDcomentarios,
                    AsigDstatus: item.data.AsigDstatus,
                    DemGestorId: item.data.DemGestorId,
                    FechaRegistro: item.data.FechaRegistro,
                  });
                  setShowModalDemanda(true);
                }}
              >
                Editar
              </button>
            </>
          ),
        })),
      });
    }
  }

   
  return (
    <>
      <AcreditadoInfoDetalle acreditadoInfo={acreditadoInfo} />
      {/* <GestorInfo /> */}

      <div className="AcreditadosDetalle__container">
        <div className="mdbDataTable">
          <div className="menuTab_AcreditadoDetalle">
            <div
              className={
                currentTab === 0 && "menuTabItemActive_AcreditadoDetalle"
              }
              onClick={() => setCurrentTab(0)}
            >
              Gestiones
            </div>
            <div
              className={
                currentTab === 1 && "menuTabItemActive_AcreditadoDetalle"
              }
              onClick={() => setCurrentTab(1)}
            >
              Demandas
            </div>
            <div
              className={
                currentTab === 2 && "menuTabItemActive_AcreditadoDetalle"
              }
              onClick={() => setCurrentTab(2)}
            >
              Domicilio
            </div>
            <div
              className={
                currentTab === 3 && "menuTabItemActive_AcreditadoDetalle"
              }
              onClick={() => setCurrentTab(3)}
            >
              Nvos. Domicilios y Tels.   
            </div>
            <div
              className={
                currentTab === 4 && "menuTabItemActive_AcreditadoDetalle"
              }
              onClick={() => setCurrentTab(4)}
            >
              Referencias Tels
            </div>
            <div
              className={
                currentTab === 5 && "menuTabItemActive_AcreditadoDetalle"
              }
              onClick={() => setCurrentTab(5)}
            >
              Medios de pago
            </div>
          </div>
          {currentTab === 0 && (
            <Gestiones
              setCurrentRow={setCurrentRow}
              setShowModalEdicion={setShowModalEdicion}
              id={id}
              datatable={datatableGestiones}
              ultimas7={ultimas7}
              setUltimas7={setUltimas7}
            />
          )}
          {currentTab === 1 && (
            <Demandas
              setCurrentRow={setCurrentRow}
              setShowModalEdicion={setShowModalDemanda}
              id={id}
              datatable={datatableDemandas}
              loadInfoParent={loadInfo}
            />
          )}
          {currentTab === 2 && (
            <>
              <Domicilios acreditadoInfo={acreditadoInfo} />
              <br/>
              <OtrosDomicilios acreditadoInfo={acreditadoInfo} />
            </>
          )}
          {currentTab === 3 && <NuevosDomicilios acreditadoInfo={acreditadoInfo} />}
          {currentTab === 4 && <Referencias acreditadoInfo={acreditadoInfo} />}
          {currentTab === 5 && <MediosPago acreditadoInfo={acreditadoInfo} />}
        </div>
      </div>
      {showModalEdicion && (
        <ModalAdicion
          setShow={setShowModalEdicion}
          show={showModalEdicion}
          setCurrentRow={setCurrentRow}
          currentRow={currentRow}
        />
      )}
      {showModalDemanda && (
        <ModalAdicionDemanda
          setShow={setShowModalDemanda}
          show={showModalDemanda}
          setCurrentRow={setCurrentRow}
          currentRow={currentRow}
          loadInfoParent={loadInfo}
          />
      )}
      
    </>
  );
};

export default AcreditadosDetalle;
